//////////////////////////////////////////////////////////////////
//
//  文字ハイライトアニメ
//
//////////////////////////////////////////////////////////////////

(function (document) {
  const markers = [...document.querySelectorAll('mark')];
  
  const observer = new IntersectionObserver(entries => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        entry.target.style.animationPlayState = 'running';
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.8
  });
  
  markers.forEach(mark => {
    observer.observe(mark);
  });
})(document);


//////////////////////////////////////////////////////////////////
//
//  ページメニューボタン表示 
//
//////////////////////////////////////////////////////////////////

$(document).ready(function() {
	var flag = false;
	var pagetop = $('.btn_pagenavi_block, .btn_pagenavi_block2');
	$(window).scroll(function () {
		scrollHeight = $(document).height();
		scrollPosition = $(window).height() + $(window).scrollTop();
		if (
			(scrollHeight - scrollPosition) / scrollHeight <= 0.3) {
			//スクロールの位置が下部30%の範囲に来た場合
			pagetop.addClass("slidedown");
			pagetop.removeClass("slideup");
		} else {
			//それ以外のスクロールの位置の場合
			pagetop.removeClass("slidedown");
			pagetop.addClass("slideup");
		}
	});
});

$(function () {
  setTimeout(function(){
    // メニューを半分隠す
    $(".dl-menu").css("right", "-150px");
  }, 2000);
  $(".dl-menu").hover(function() {
    // マウスが重なったときにメニューを表示する
    $(this).css("right", "0");
  });
  $(".dl-menu").mouseleave(function() {
    // マウスが離れたときにメニューを非表示にする
    $(this).css("right", "-150px");
  });
});

//////////////////////////////////////////////////////////////////
//
//  ヘッダーメニュー
//  スクロール
//
//////////////////////////////////////////////////////////////////

/*$(function(){
  var pos1 = 0;
  var header = $('.header');
  var width1 = $(window).width();

  $(window).on('scroll', function(){
    // ここでmain要素にクラスがあるかチェックします
    if (!$('main').hasClass('no-header-fx')) {
      // ↓このブロック全体が、機能させたいページでのみ実行されます
      if(width1 > 1023 && $(this).scrollTop() < pos1 && $(this).scrollTop() !== 0){
        //上スクロール時の処理
        header.addClass('fixed');
        header.addClass('dw');
        header.removeClass('up');
      } else if (width1 > 1023 && $(this).scrollTop() < pos1 && $(this).scrollTop() == 0) {
        header.removeClass('fixed');
        header.removeClass('dw');
        header.removeClass('up');
      } else if (width1 > 1023 && $(this).scrollTop() <! pos1 && $(this).scrollTop() == 0) {
        header.removeClass('fixed');
        header.removeClass('dw');
        header.removeClass('up');
      }else{
        //下スクロール時の処理
        header.removeClass('dw');
        header.addClass('up');
      }
    }
    
    pos1 = $(this).scrollTop();

    if(width1 < 1023){
      header.removeClass('fixed');
      header.removeClass('dw');
      header.removeClass('up');
    }
  });
});*/

//////////////////////////////////////////////////////////////////
//
//  フローティングメニュー
//  スクロール
//
//////////////////////////////////////////////////////////////////

$(function(){
  var pos2 = 0;
  var width2 = $(window).width();
  var pageheader = $(
    '.pageheader, .pageheader2, .pagemenu, .page-prod-menu, .page-prod-nav'
  );
  
  $(window).on('scroll', function(){
    // ここでmain要素にクラスがあるかチェックします

      // ↓このブロック全体が、機能させたいページでのみ実行されます
      if(width2 > 1023 && $(this).scrollTop() < pos2 && $(this).scrollTop() !== 0){
        // header挙動時のページメニュー動作
        //pageheader.addClass('dw');
        //pageheader.removeClass('up');
      } else if (width2 > 1023 && $(this).scrollTop() < pos2 && $(this).scrollTop() == 0) {
        pageheader.removeClass('dw');
      } else if (width2 > 1023 && $(this).scrollTop() <! pos2 && $(this).scrollTop() == 0) {
        pageheader.removeClass('dw');
        pageheader.removeClass('up');
      }else{
        pageheader.removeClass('dw');
        pageheader.addClass('up');
      }

    pos2 = $(this).scrollTop();
  });
});

//////////////////////////////////////////////////////////////////
//
//  ヘッダー＋フローティングメニュー
//  スクロール（自動追従）
//
//////////////////////////////////////////////////////////////////

/*$(function(){
  var pos1 = 0;
  var header = $('.header');
  var width1 = $(window).width();
  
  var pageheader = $(
    '.pageheader, .pageheader2, .pagemenu, .page-prod-menu, .page-prod-nav'
  );
   
  $(window).on('scroll', function(){
    // ここに条件分岐を追加します
    //if (!$('body').hasClass('no-header-fx')) {
      // ↓このブロック全体が、機能させたいページでのみ実行されます
      if(width1 > 1023 && $(this).scrollTop() < pos1 && $(this).scrollTop() !== 0){
        //上スクロール時の処理
        header.addClass('fixed');
        header.addClass('dw');
        header.removeClass('up');

        // header挙動時のページメニュー動作
        pageheader.addClass('dw');
        pageheader.removeClass('up');

      } else if (width1 > 1023 && $(this).scrollTop() < pos1 && $(this).scrollTop() == 0) {
        header.removeClass('fixed');
        header.removeClass('dw');
        header.removeClass('up');

        pageheader.removeClass('dw');
        //pageheader.removeClass('up');

      } else if (width1 > 1023 && $(this).scrollTop() <! pos1 && $(this).scrollTop() == 0) {
        header.removeClass('fixed');
        header.removeClass('dw');
        header.removeClass('up');

        pageheader.removeClass('dw');
        pageheader.removeClass('up');

      }else{
        //下スクロール時の処理
        header.removeClass('dw');
        header.addClass('up');

        // header挙動時のページメニュー動作
        pageheader.removeClass('dw');
        pageheader.addClass('up');
      }
    //}
    
    pos1 = $(this).scrollTop();

    if(width1 < 1023){
      header.removeClass('fixed');
      header.removeClass('dw');
      header.removeClass('up');
    }
   });
});*/

$(function(){
	$(window).on('scroll', function(){

		const menuLeft = $('.menu-appfilds02-lft');
		const menuRight = $('.menu-appfilds02-rgt');
		const scrollMenu = $(window).scrollTop();

		if(scrollMenu >= 4500 && scrollMenu <= 9500 ){
			menuLeft.css("left", "5px");
		} else if (scrollMenu < 4500 || scrollMenu > 9500) {
			menuLeft.css("left", "-150px");
		} else {
			menuLeft.css("left", "-150px");
		}

		if(scrollMenu >= 9500 && scrollMenu <= 15000 ){
			menuRight.css("right", "5px");
		} else if (scrollMenu < 9500 || scrollMenu > 15000) {
			menuRight.css("right", "-150px");
		} else {
			menuRight.css("right", "-150px");
		}
  });
});

$(function () {
  setTimeout(function(){
    // メニューを半分隠す
    $(".dl-menu").css("right", "-150px");
  }, 2000);
  $(".dl-menu").hover(function() {
    // マウスが重なったときにメニューを表示する
    $(this).css("right", "0");
  });
  $(".dl-menu").mouseleave(function() {
    // マウスが離れたときにメニューを非表示にする
    $(this).css("right", "-150px");
  });
});

$(function(){
  //var btn = $('.button');
	var btn = $('.btn-contact-sensor');
  var timer;
	var pos2 = 0;
	var width3 = $(window).width();

	var menufloatbtm = $('.menu-float-btm');
  
	if(width3 > 1024){
		$(window).scroll(function() {
			//スクロール開始するとボタンを非表示
			//btn.removeClass('is-active');
			btn.removeClass('up');
			btn.addClass('dw');

			menufloatbtm.removeClass('up');
			menufloatbtm.addClass('dw');
			
			//スクロール中はイベントの発火をキャンセルする
			clearTimeout(timer);
			
			//スクロールが停止して0.2秒後にイベントを発火する
			timer = setTimeout(function() {
				//スクロール位置を判定してページ上部のときはボタンを非表示にする
				if($(this).scrollTop()) {
					//btn.addClass('is-active');
					btn.removeClass('dw');
					btn.addClass('up');

					menufloatbtm.removeClass('dw');
					menufloatbtm.addClass('up');
				}else{
					//btn.removeClass('is-active');
					btn.removeClass('up');
					btn.addClass('dw');

					menufloatbtm.removeClass('up');
					menufloatbtm.addClass('dw');
				}
			}, 200);
		});
	}else{
		$(window).on('scroll', function(){
			btn.removeClass('up');
			btn.addClass('dw');

			menufloatbtm.removeClass('up');
			menufloatbtm.addClass('dw');
			clearTimeout(timer);
			timer = setTimeout(function() {
				if($(this).scrollTop() < pos2 && $(this).scrollTop() !== 0 ){
					//上にスクロール時ボタン挙動
					btn.removeClass('up');
					btn.addClass('dw');

					menufloatbtm.removeClass('up');
					menufloatbtm.addClass('dw');
				}else{
					//下にスクロール時ボタン挙動
					btn.removeClass('dw');
					btn.addClass('up');

					menufloatbtm.removeClass('dw');
					menufloatbtm.addClass('up');
				}
				pos2 = $(this).scrollTop();
			}, 200);
		});
	}
  
  //ボタンクリックでトップへ戻る
  //btn.on('click',function () {
  //  $('body,html').animate({
  //    scrollTop: 0
  //  });
  //});
});

//////////////////////////////////////////////////////////////////
//
//  スクロール途中で横スクロール
//
//////////////////////////////////////////////////////////////////

"use strict";

document.addEventListener("DOMContentLoaded", () => {
  /* horizontal scroll */
  const stickyContainers = document.querySelectorAll(".horizontal_scroll");

  stickyContainers.forEach((stickyContainer) => {
    // get elements
    const stickyItem = stickyContainer.querySelector(".sticky");
    const scroller = stickyContainer.querySelector(".scroller");
    scroller.classList.add("nobar");

    // set sticky height
    const updateStickyHeight = () => {
      const stickyHeight = scroller.scrollWidth - scroller.clientWidth + stickyItem.clientHeight;
      stickyContainer.style.setProperty("--sticky-container-height", `${stickyHeight}px`);
    };
    updateStickyHeight();
    new ResizeObserver(updateStickyHeight).observe(scroller);
    new ResizeObserver(updateStickyHeight).observe(stickyItem);

    // sync scroll
    const syncScroll = () => {
      const rect = stickyContainer.getBoundingClientRect();
      if (rect.top <= 0 && rect.bottom >= window.innerHeight) {
        scroller.scrollLeft = window.scrollY - stickyContainer.offsetTop;
      } else if (rect.bottom < window.innerHeight) {
        scroller.scrollLeft = scroller.scrollWidth - scroller.clientWidth;
      } else {
        scroller.scrollLeft = 0;
      }
    };
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener("scroll", syncScroll, { passive: true });
            syncScroll();
          } else {
            window.removeEventListener("scroll", syncScroll);
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(stickyContainer);

    // end of forEach
  });

  // end of DOMContentLoaded
});

////////////////////////////////////////////////////////
//
//  anime-trigger
//
////////////////////////////////////////////////////////

$(document).ready(function() {

	// フェードエフェクト
  scroll_effect();

  $(window).scroll(function(){
    scroll_effect();
  });

  function scroll_effect(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.fx').each(function(i){
      var elemPos = $(this).offset().top;
      var target = this;
      if (scroll > elemPos - windowHeight){
        setTimeout(function () {
          $(target).addClass("scrollin");
        }, 2 * i );
      }
    });
    $('.sldbar').each(function(i){
      var elemPos = $(this).offset().top;
      var target = this;
      if (scroll > elemPos - windowHeight){
        let delay = 100;
        $(this).delay(i * delay).queue(function(next){
          $(this).addClass('scrollin');
          next();
        })
      }
    });
  }
});

////////////////////////////////////////////////////////
//
//  Page Top
//
////////////////////////////////////////////////////////

document.addEventListener('DOMContentLoaded', function() {
  let pos = 0;
  const footerMenu = document.querySelector('.pagetop');
  const width = window.innerWidth;

  if (width > 1024) {
    window.addEventListener('scroll', function() {
      const currentScroll = window.scrollY;

      if (currentScroll > pos) {
        footerMenu.classList.remove('dw');
        //footerMenu.classList.add('up');
      } else {
        footerMenu.classList.remove('up');
        //footerMenu.classList.add('dw');
      }
      
      pos = currentScroll;
    });
  }
});

////////////////////////////////////////////////////////
//
//  製品ページサイドメニューボタンアンダーライン挙動
//
////////////////////////////////////////////////////////

/*document.addEventListener('DOMContentLoaded', function() {
  const navLinks = document.querySelectorAll('.btn-scrollspy a');
  let isScrollingFromClick = false;
  let scrollTimer = null;
  let lastActiveId = null;

  // 各セクションの情報を収集
  const sections = Array.from(navLinks).map(link => {
    const href = link.getAttribute('href');
    if (!href) return null;
    
    const targetId = href.substring(1);
    let targetElement = null;
    
    // まず .scroll-id を持つ要素を探す
    const scrollIdElement = document.querySelector(`#${targetId}.scroll-id`);
    if (scrollIdElement) {
      targetElement = scrollIdElement;
    } else {
      // なければ通常のID要素
      targetElement = document.getElementById(targetId);
    }
    
    if (!targetElement) {
      console.warn(`要素が見つかりません: #${targetId}`);
      return null;
    }
    
    return {
      id: targetId,
      element: targetElement,
      link: link
    };
  }).filter(section => section !== null);

  if (sections.length === 0) {
    console.error('対象セクションが見つかりません');
    return;
  }

  // アクティブリンクを更新する関数
  function setActiveLink(sectionId) {
    if (lastActiveId === sectionId) return;
    
    lastActiveId = sectionId;
    navLinks.forEach(link => link.classList.remove('active-uline'));
    
    const targetSection = sections.find(s => s.id === sectionId);
    if (targetSection) {
      targetSection.link.classList.add('active-uline');
    }
  }

  // クリックイベント
  navLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const href = this.getAttribute('href');
      if (!href) return;
      
      const targetId = href.substring(1);
      const targetSection = sections.find(s => s.id === targetId);
      
      if (!targetSection) return;

      // クリックフラグをオン
      isScrollingFromClick = true;
      
      // アクティブ状態を即座に更新
      setActiveLink(targetId);
      
      // スクロール実行
      targetSection.element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
      
      // スクロール完了後にフラグをオフ
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        isScrollingFromClick = false;
      }, 1200);
    });
  });

  // 各要素の正確な位置を取得する関数
  function getElementTop(element) {
    let top = 0;
    let el = element;
    while (el) {
      top += el.offsetTop;
      el = el.offsetParent;
    }
    return top;
  }

  // スクロール監視
  function checkScroll() {
    if (isScrollingFromClick) return;

    // 現在のスクロール位置（画面上部から250px下を基準）
    const scrollPos = window.scrollY + 250;
    
    let currentSection = null;
    
    // 各セクションの正確な位置を計算
    const sectionPositions = sections.map(section => ({
      ...section,
      top: getElementTop(section.element)
    }));
    
    // 後ろから順に確認
    for (let i = sectionPositions.length - 1; i >= 0; i--) {
      if (scrollPos >= sectionPositions[i].top) {
        currentSection = sectionPositions[i];
        break;
      }
    }
    
    // 見つからない場合は最初のセクション
    if (!currentSection) {
      currentSection = sectionPositions[0];
    }
    
    // アクティブリンクを更新
    if (currentSection) {
      setActiveLink(currentSection.id);
    }
  }

  // スクロールイベント
  let rafId = null;
  window.addEventListener('scroll', function() {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(checkScroll);
  }, { passive: true });

  // 初期チェック
  checkScroll();
});*/
document.addEventListener('DOMContentLoaded', function() {
  // 1. まずナビゲーション要素自体が存在するか確認
  const navLinks = document.querySelectorAll('.btn-scrollspy a');
  if (navLinks.length === 0) return; // リンクがなければ何もしない

  let isScrollingFromClick = false;
  let scrollTimer = null;
  let lastActiveId = null;

  // 2. セクション情報を収集（存在する要素だけを抽出）
  const sections = Array.from(navLinks).map(link => {
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return null;
    
    const targetId = href.substring(1);
    //let targetElement = document.querySelector(`#${targetId}.scroll-id`) || document.getElementById(targetId);
    let targetElement = document.getElementById(targetId);
    
    // 要素が見つからない場合は null を返して除外対象にする
    if (!targetElement) return null;
    
    return {
      id: targetId,
      element: targetElement,
      link: link
    };
  }).filter(section => section !== null);

  // 3. 有効なセクションが一つもない場合はここで終了
  if (sections.length === 0) return;

  // アクティブリンクを更新する関数
  function setActiveLink(sectionId) {
    if (lastActiveId === sectionId) return;
    
    lastActiveId = sectionId;
    // 全てのリンクからクラスを削除
    navLinks.forEach(link => link.classList.remove('active-btn-fx'));
    
    // 現在のセクションに対応するリンクだけにクラスを付与
    const targetSection = sections.find(s => s.id === sectionId);
    if (targetSection) {
      targetSection.link.classList.add('active-btn-fx');
    }
  }

  // クリックイベントの設定
  sections.forEach(section => {
    section.link.addEventListener('click', function(e) {
      e.preventDefault();
      
      isScrollingFromClick = true;
      setActiveLink(section.id);
      
      section.element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
      
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        isScrollingFromClick = false;
      }, 1200);
    });
  });

  // 各要素の正確な位置を取得する関数
  function getElementTop(element) {
    let top = 0;
    let el = element;
    while (el) {
      top += el.offsetTop;
      el = el.offsetParent;
    }
    return top;
  }

  // スクロール監視
  function checkScroll() {
    if (isScrollingFromClick) return;

    const scrollPos = window.scrollY + 250;
    let currentSection = null;
    
    const sectionPositions = sections.map(section => ({
      ...section,
      top: getElementTop(section.element)
    }));
    
    for (let i = sectionPositions.length - 1; i >= 0; i--) {
      if (scrollPos >= sectionPositions[i].top) {
        currentSection = sectionPositions[i];
        break;
      }
    }
    
    // 最初のセクションより上にいる場合は、どのアクティブも付けないか、
    // 最初のセクションをアクティブにするかはお好みで調整可能です
    if (currentSection) {
      setActiveLink(currentSection.id);
    }
  }

  // スクロールイベント（パフォーマンス向上のため raf を使用）
  let rafId = null;
  window.addEventListener('scroll', function() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(checkScroll);
  }, { passive: true });

  // 初期実行
  checkScroll();
});